import type { FileItem } from "@/features/my-files/types";

import AssetFolder from "@/features/my-files/assets/asset-folder.svg?react";
import { FILE_ICONS } from "@/features/my-files/assets/file-icons";

export function FileIcon({
  className,
  fileItem,
}: {
  className?: string;
  fileItem: FileItem;
}) {
  if (fileItem.type === "folder") return <AssetFolder className="shrink-0" />;

  const Icon =
    FILE_ICONS[fileItem.extension as keyof typeof FILE_ICONS] ??
    FILE_ICONS.fallback;

  return <Icon className={className ?? "size-3xl shrink-0"} />;
}
